import { VirtualCardAuthCard } from '@ott/shared-virtual-card-logic';
import cardValidator from '@ott/utility-card-validator';

import { RefillCard } from '../types';

const notANumberRegExp = /\D/;

export const prepareRefillCards = (cards: VirtualCardAuthCard[]) => {
  return cards
    .filter((card) => !card.isOTTCard)
    .map(({ cardHolder, cardId, cardMask, cardName, status, isOTTCard }) => {
      const bin = cardMask?.replace(notANumberRegExp, '').slice(0, 6);

      const cardNumberWithoutSpaces = cardMask.replace(/\s/, '');

      const hasNotOnlyDigit = notANumberRegExp.test(cardNumberWithoutSpaces);
      const { card } = cardValidator.number(hasNotOnlyDigit ? bin : cardNumberWithoutSpaces);

      const issuingNetwork = (card && card.type.replace(/\W/, '')) || 'default';

      const cardNumber = cardMask
        .match(/.{1,4}|^$/g)
        ?.join(' ')
        .replace(/x/g, '•');

      return {
        cardHolder,
        cardId,
        cardMask,
        cardNumber,
        cardName,
        status,
        isOTTCard,
        issuingNetwork: issuingNetwork as string,
      } as RefillCard;
    });
};
